import i18n from "@/i18n";
import type { IMenuRoute } from "@/models/routes";

export const AccountRoutes: () => IMenuRoute[] = () => [
  {
    label: i18n.t("_.profile"),
    to: {
      name: "adminAccountProfile"
    }
  },
  {
    label: i18n.t("_.security"),
    to: {
      name: "adminAccountSecurity"
    }
  },
  {
    label: "_.notifications",
    to: {
      name: "adminAccountNotifications"
    }
  },
  {
    label: i18n.t("_.logs"),
    to: {
      name: "adminAccountLogs"
    },
    children: [
      {
        label: i18n.t("_.activity_log"),
        to: {
          name: "adminAccountActivityLog"
        }
      },
      {
        label: i18n.t("_.login_attempt_log"),
        to: {
          name: "adminAccountLoginAttempts"
        }
      },
      {
        label: i18n.t("_.email_history_log"),
        to: {
          name: "adminAccountEmailHistory"
        }
      }
    ]
  }
];
